import { FormMode } from 'src/app/controls/common/form-mode';
import { IParamsValues } from 'src/app/models/interfaces/params-values.interface';

export class ParametersValuesFormContext {
    /**
     * Instance du type de document affiché dans le formulaire.
     */
    public paramsValues: IParamsValues;

    public groupParentParamsValues: IParamsValues;

    /**
     * Indique si le formulaire est visible (true) ou pas (false).
     */
    public formVisible = false;

    public formMode: FormMode = FormMode.Reading;
}
